var indexOf = [].indexOf;

import underscored from 'underscore.string/underscored';

import featureNames from 'constants/feature_names';

angular.module('gym.contacts').controller('EditMembershipCtrl', ["$scope", "$state", "$stateParams", "$modal", "$http", "loadingAnimation", "flash", "isInteger", "MembershipIntervalUnits", "EventService", "MembershipPlanService", "EmploymentService", "gym", "contact", "membership", "membershipPlanCategories", "gradingStyles", function($scope, $state, $stateParams, $modal, $http, loadingAnimation, flash, isInteger, MembershipIntervalUnits, EventService, MembershipPlanService, EmploymentService, gym, contact, membership, membershipPlanCategories, gradingStyles) {
  var addEmptyCategory, base, reloadEventTypes;
  $scope.gym = gym.attributes;
  $scope.permissions = EmploymentService.get().permissions;
  $scope.currency = $scope.gym.currency_symbol;
  $scope.contact = contact;
  $scope.membership = membership;
  $scope.membershipPlanCategories = membershipPlanCategories;
  $scope.membership_interval_unit_pairs = _.pairs(MembershipIntervalUnits);
  $scope.featureNames = featureNames;
  $scope.gradingStyles = gradingStyles;
  $scope.isMartialArts = $scope.gym.is_martial_arts;
  $scope.membership.not_classes_interval = membership.classes_unlimited || !membership.classes_interval_number;
  $scope.membership.cc_invoice_receipt_enabled = !!$scope.membership.cc_invoice_receipts_to;
  (base = $scope.membership).future_booking_term_unit || (base.future_booking_term_unit = 'weeks');
  $scope.automaticRescheduleLimits = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  $scope.recurringPaymentInfo = null;
  if (!$scope.membership.category_id) {
    $scope.membership.category_id = null;
  }
  $scope.contactsType = function(type) {
    return `${underscored(type)}s`;
  };
  $scope.isPaymentEachDayMembership = function(membership) {
    return membership.cost_repeat > 0 && membership.charge_interval_number === 1 && membership.charge_interval_unit === 'days';
  };
  $scope.shouldShowChangePaymentDate = function(membership) {
    return $scope.permissions.manage_payment_status && $scope.recurringPaymentInfo.future_payments_count > 1 && !$scope.isPaymentEachDayMembership(membership);
  };
  $scope.realignInvoicePlanMembership = function() {
    var params;
    params = {
      contactType: $scope.contactsType(contact.type),
      contactId: contact.id,
      membership_id: membership.id,
      membership_name: membership.label
    };
    return $state.go('gym.contacts.invoicePlanMembershipRealignments', params);
  };
  if (membership.payment_plan_version === 'v2_invoice_plan') {
    $http.get(`/gyms/${$scope.gym.id}/${$scope.contactsType(contact.type)}/${contact.id}/memberships/${membership.id}/next_payment_details`).then(function(response) {
      return $scope.recurringPaymentInfo = response.data;
    });
  }
  addEmptyCategory = function() {
    if (!_.find($scope.membershipPlanCategories, function(category) {
      return !category.id;
    })) {
      return $scope.membershipPlanCategories.unshift({
        id: null,
        label: 'No category'
      });
    }
  };
  addEmptyCategory();
  EventService.eventTypesWithDeleted($scope.membership.event_type_ids).then(function(types) {
    return $scope.eventTypes = types;
  });
  $scope.isTypeSelected = function(id) {
    return indexOf.call($scope.membership.event_type_ids, id) >= 0;
  };
  $scope.isStyleSelected = function(id) {
    return indexOf.call($scope.membership.style_ids, id) >= 0;
  };
  $scope.toggleType = function(id) {
    if ($scope.isTypeSelected(id)) {
      return $scope.membership.event_type_ids = _.without($scope.membership.event_type_ids, id);
    } else {
      return $scope.membership.event_type_ids.push(id);
    }
  };
  $scope.toggleStyle = function(id) {
    if ($scope.isStyleSelected(id)) {
      return $scope.membership.style_ids = _.without($scope.membership.style_ids, id);
    } else {
      return $scope.membership.style_ids.push(id);
    }
  };
  $scope.onSendInvoiceReceiptChanged = function() {
    $scope.membership.tax_status = '';
    if (!$scope.membership.send_invoice_receipts) {
      $scope.membership.cc_invoice_receipt_enabled = false;
      return $scope.membership.cc_invoice_receipts_to = '';
    }
  };
  $scope.onCcInvoiceReceiptToggleChanged = function() {
    if (!$scope.membership.cc_invoice_receipt_enabled) {
      return $scope.membership.cc_invoice_receipts_to = '';
    }
  };
  reloadEventTypes = function() {
    return EventService.eventTypesWithDeleted($scope.membership.event_type_ids).then(function(types) {
      return $scope.eventTypes = types;
    });
  };
  $scope.manageTypes = function() {
    var roomModal;
    roomModal = $modal.open({
      template: require('templates/gyms/calendar/events/manage_types.html.slim'),
      controller: 'ManageEventTypesModal',
      resolve: {
        types: function() {
          return $scope.eventTypes;
        }
      }
    });
    return roomModal.result.then(function() {
      return reloadEventTypes();
    }, function() {
      return reloadEventTypes();
    });
  };
  $scope.recurringBookingsDisabled = function() {
    return !$scope.membership.classes_unlimited && (!$scope.membership.classes_interval_number || $scope.membership.not_classes_interval);
  };
  $scope.onClassesIntervalChanged = function() {
    $scope.membership.classes_interval_number = 0;
    return $scope.membership.allow_recurring_bookings = false;
  };
  $scope.onClassesLimitTypeChanged = function() {
    var base1;
    $scope.membership.classes_limit = 0;
    if ($scope.membership.classes_unlimited) {
      $scope.membership.classes_interval_number = 0;
      $scope.membership.not_classes_interval = true;
      return (base1 = $scope.membership).future_booking_term_unit || (base1.future_booking_term_unit = 'weeks');
    } else {
      $scope.membership.restrict_future_bookings_by_count = false;
      $scope.membership.restrict_future_bookings_by_date = false;
      $scope.membership.future_bookings_count_limit = null;
      $scope.membership.future_booking_term_number = null;
      $scope.membership.future_booking_term_unit = null;
      return $scope.membership.allow_recurring_bookings = false;
    }
  };
  $scope.openMembershipPlanCategoryManagement = function() {
    return $modal.open({
      template: require('templates/gyms/membership_plans/membershipPlanCategoryManagement.html.slim'),
      controller: 'MembershipPlanCategoryManagementCtrl',
      resolve: {
        onCategoryChange: function() {
          return function() {
            return $scope.membershipPlanCategories.reload().then(function() {
              return addEmptyCategory();
            });
          };
        }
      }
    });
  };
  $scope.save = function() {
    return MembershipPlanService.validate($scope.membership).then(function() {
      var url;
      $scope.membership.errors = void 0;
      url = `/gyms/${$stateParams.gymId}/${$stateParams.contactType}/${$stateParams.contactId}/memberships/${membership.id}`;
      return $http.patch(url, {
        membership: $scope.membership
      }).then(function(response) {
        flash.success = 'Membership successfully updated';
        return $state.go('gym.contacts.edit', {
          contactId: $stateParams.contactId
        });
      }, function(response) {
        flash.error = 'Update failed. Please fix the errors below';
        return $scope.membership.errors = response.data.errors;
      });
    });
  };
  $scope.cancel = function() {
    return $state.go('gym.contacts.edit', {
      contactId: contact.id
    });
  };
  $scope.isMembershipValid = function() {
    return $scope.membership.label && $scope.isClassesLimitValid() && $scope.isClassesIntervalValid() && !MembershipPlanService.hasInvalidTypeLimit($scope.membership.per_event_type_limits);
  };
  $scope.isClassesLimitValid = function() {
    var limit;
    limit = $scope.membership.classes_limit;
    return (parseInt(limit, 10) >= 0 && isInteger(limit)) || $scope.membership.classes_unlimited;
  };
  $scope.isClassesIntervalValid = function() {
    var interval;
    interval = $scope.membership.classes_interval_number;
    return (parseInt(interval, 10) >= 0 && isInteger(interval)) || $scope.membership.not_classes_interval;
  };
  $scope.onAutomaticRescheduleToggle = function() {
    if ($scope.membership.perform_automatic_reschedule) {
      $scope.membership.automatic_reschedule_days = 1;
      return $scope.membership.automatic_reschedule_limit = 3;
    } else {
      $scope.membership.automatic_reschedule_days = 0;
      return $scope.membership.automatic_reschedule_limit = 0;
    }
  };
  $scope.displayFutureBookingLimitsDescription = function(event, type) {
    event.preventDefault();
    return $modal.open({
      template: require('templates/components/membership_plan/future_booking_limits.html.slim'),
      controller: 'FutureBookingLimitsModal',
      resolve: {
        type: function() {
          return type;
        }
      }
    });
  };
  $scope.displayRecurringBookingsDescription = function(event) {
    event.preventDefault();
    return EventService.displayRecurringBookingsDescription();
  };
  return $scope.displayTrialMembershipDescription = function(event) {
    event.preventDefault();
    return MembershipPlanService.displayTrialMembershipDescription($scope.featureNames);
  };
}]);
